import { defineStore } from 'pinia'
import $api from '@/plugins/axios';

export const useAttendanceStore = defineStore('AttendanceStore',{
  state: () => {
    return {
      todayStudent: {
        content: [],
        pageInfo: {}
      },
      todayCnt: null,
      historyAttendance: {
        content: [],
        pageInfo: {}
      },
      userAttendanceDetails: []
    }
  },
  actions: {
    async getAttendanceToday(params) {
      const res = await $api.get(`/attendances/today`, { params });
      this.todayStudent.content = res.content;
      this.todayStudent.pageInfo = res.pageInfo;
    },
    async getAttendanceTodayCount(params) {
      const res = await $api.get('/attendances/todayCnt', {params});
      this.todayCnt = res.data;
    },
    async getAttendanceReports(params){
      const res = await $api.get(`/attendances/reports`, {params});
      this.historyAttendance = res.listTypeItems;
    },
    async getUserAttendanceDetail(params){
      const res = await $api.get(`/attendances/users/${params.userId}/details`, {params});
      const data = res
      data.sort((a, b) => {
        return Number(b.userStudyId) - Number(a.userStudyId);
      });
      this.userAttendanceDetails = data;
    }
  },
})
